import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActiveCartFacade, OrderEntry } from '@spartacus/cart/base/root';
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core';

@Component({
    selector: 'knbr-cart-page-modal',
    templateUrl: './cart-page-modal.component.html',
    styleUrl: './cart-page-modal.component.scss'
})
export class CartPageModalComponent {
 @Input() item: OrderEntry;
constructor(private ngbActiveModal:NgbActiveModal,private activeCartService: ActiveCartFacade, private messageService: GlobalMessageService,){}

hideDeletePopup(){
  this.ngbActiveModal.close();
}
confirmDelete(){
     this.activeCartService.removeEntry(this.item);
      this.ngbActiveModal.close();
      this.messageService.add('Cart item has been deleted', GlobalMessageType.MSG_TYPE_CONFIRMATION);
}
}
